import { Catalog } from '@df/catalog/catalog.interfaces';
import { NICmsContentComponent } from '@icms/core/content';

export namespace NProductViewLayout {
    export const BLOCK_ID = 'cms-product-view-layout';

    export type IBlockData = Catalog.IBlockData<IBlockDataContent>;

    export interface IBlockDataContent {
        bottomComponents: NICmsContentComponent.IData[];
        attributes: string[];
        getSampleUrl?: string;
        getSampleTitle?: string;
        getSampleSubtitle?: string;
        talkToExpertImage?: string;
        talkToExpertUrl?: string;
        talkToExpertTitle?: string;
        talkToExpertDescription?: string;
        priceListDescription?: string;
        additionalLeadTimeText?: string;
        trustpilotMiniTemplateId?: string;
        trustpilotBusinessunitId?: string;
    }
}
